import styled from 'styled-components';
import { black, border1, green, lightGrayBackground } from 'utils/style/colors';

export const AutoCompleteAiControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`;

export const AutoCompleteAiPrimaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  width: 100%;
`;

export const AiModelField = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
  border: none;
  margin: 0;
  padding: 0;
`;

export const AiModelLabel = styled.legend`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${black};
  padding: 0;
`;

export const AiModelRadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  align-items: center;
`;

export const AiCompletionTimer = styled.div<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.5rem 0.65rem;
  border-radius: 0.75rem;
  border: ${border1};
  background: ${(props) =>
    props.active ? 'rgba(66, 97, 253, 0.08)' : lightGrayBackground};
  color: ${black};
  font-size: 0.875rem;
  white-space: nowrap;
  min-height: 2.35rem;
  justify-content: center;
  flex: 0 0 auto;
`;

export const AiCompletionTimerValue = styled.span`
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: ${green};
`;
